import type { JSX, ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  body: string;
  action?: ReactNode;
  icon?: ReactNode;
}

export function EmptyState({ title, body, action, icon }: EmptyStateProps): JSX.Element {
  return (
    <div
      data-testid="empty-state"
      className="flex flex-col items-center gap-3 rounded-[var(--radius-card)] border border-[var(--color-line)] bg-[var(--color-slab)] p-6 text-center"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[var(--color-lime)]/20 bg-[var(--color-void)] text-[var(--color-lime)]">
        {icon ?? (
          <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="2" y1="6" x2="22" y2="6" />
            <line x1="6" y1="6" x2="6" y2="18" />
            <line x1="18" y1="6" x2="18" y2="18" />
            <circle cx="6" cy="19" r="1.5" />
            <circle cx="18" cy="19" r="1.5" />
          </svg>
        )}
      </div>
      <h3 className="font-subhead text-sm uppercase tracking-[0.06em] text-[var(--color-ink-hi)]">
        {title}
      </h3>
      <p className="max-w-xs font-sans text-sm text-[var(--color-ink-mute)]">{body}</p>
      {action}
    </div>
  );
}
